import { getState, modifyState } from '~src/state';

export const updateChangeClothesBrush = () => {
  const brushRadius = getState('changeClothesBrushRadius');
  const mouseCursor = getState('mouseCursorChangeClothes');
  mouseCursor.set('radius', brushRadius);
  modifyState('mouseCursorMagicEraser', mouseCursor);
  window.changeClothesDrawingCanvas.freeDrawingBrush.width = brushRadius * 2;
  window.cursorCanvas.renderAll();
};
